import React, {useEffect} from 'react';
import TemplateInformPage from '../../../Components/TemplateInformPage';
import { Localization } from '../../../Common/Localization';
import { config } from '../../../Config/Config';
import {ReactComponent as ExpiredIcon} from "../../../Resources/token-expired.svg";

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
  },
  alignCenter: {
    alignSelf: 'center'
  }
};

function SessionExpiredPage() {
  let iconStroke = config.theme.iconColor || "#368FBB";
  let iconFill = config.theme.iconFill || "#EBF4F8";
  useEffect(() => {
    iconStroke = config.theme.iconColor;
    iconFill = config.theme.iconFill;
  }, [config.theme.iconColor, config.theme.iconFill]);
  if (config.useCustomHtml) {
    return  <iframe style={{width:'100%', height:'calc(100% + 40px)'}} src={process.env.PUBLIC_URL + "/CustomHtml/sessionExpire.html"}></iframe>
  }
  return (
  <div style={{...styles.container}}>
    <div style={{...styles.alignCenter}}>
      <ExpiredIcon fill={iconFill} stroke={iconStroke}/>
    </div>
    <TemplateInformPage
        title={Localization.SESSION_EXPIRED_TITLE}
        text={Localization.SESSION_EXPIRED_TEXT}
        subText={Localization.SESSION_EXPIRED_SUB_TEXT}
    />
    <div style={{height: 50}}></div>
  </div>
  );
}

export default SessionExpiredPage;
